import { FC } from 'react';
import { NextgenDOMPurify } from '@nextgen-web-framework/all';
import type { RichTextComponentProps } from './types/propsTypes';
import styles from './RichTextComponent.module.scss';

const RichTextComponent: FC<RichTextComponentProps> = (data) => {
  let contentText = '';

  if (data.content) {
    if (data.sanitize) {
      contentText = NextgenDOMPurify(data.content, data.sanitizationConfig);
    } else {
      contentText = data.content;
    }
  }
  return (
    <div className={styles['rich-text-container']} data-testid={'rich-text-container-test-id'}>
      {data.title && data.title !== '' && <h2 className={styles['title-text']}>{data.title}</h2>}
      {<div className={styles['content-text']} dangerouslySetInnerHTML={{ __html: contentText }}></div>}
    </div>
  );
};

export default RichTextComponent;
export type { RichTextComponentProps };
